module.exports = __webpack_public_path__ + "img/nabuco_header.8ad73115.png";